"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
function LoadingAnimation(_a) {
    var _b = _a.color, color = _b === void 0 ? theme_1.default.colorsPalette.blue.default : _b;
    return react_1.default.createElement(styles_1.MainContainer, { color: color });
}
exports.default = LoadingAnimation;
//# sourceMappingURL=index.js.map